// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1Nvqm","modalFooterButton":"ModalNotes_modalFooterButton__wReVB"};